export enum RosteringMethod {
  ONE_ROSTER = 'ONE_ROSTER',
  SFTP = 'SFTP',
  SIS_API = 'SIS_API',
}
